<template>
  <b-sidebar id="filter-batch-sidebar" bg-variant="white" no-header right shadow backdrop>
    <template #default="{ hide }">
      <div class="container-wrapper">
        <section class="header">
          <div class="guides-info-title">Filtros</div>
          <div class="actions">
            <Close class="close" @click="hide" />
          </div>
        </section>

        <section class="guides-summary-items">
          <b-form-group>
            <label for="product_or_batch">
              Nome do produto / Lote
            </label>
            <div class="search-container">
              <Search class="icon-search" />
              <b-form-input
                  id="product_or_batch"
                  v-model="filters.query"
                  debounce="500"
                  placeholder="Nome do produto/ lote"
              />
            </div>
          </b-form-group>

          <b-form-group>
            <label for="stock_id">
              Estoque
            </label>
            <multiselect
                class="with-border"
                id="provider"
                v-model="selectedStockLocation"
                @input="changeSelectedStockLocation"
                track-by="id"
                label="name"
                placeholder="Selecionar"
                :options="stockLocations"
                :searchable="true"
                :allow-empty="true"
                :option-height="40"
                :internal-search="false"
                :showLabels="false"
            >
              <template slot="caret">
                <div class="chevron">
                  <v-chevron-down />
                </div>
              </template>
              <template slot="noOptions"> Nenhuma opção </template>
              <template slot="noResult"> Nenhum resultado </template>
            </multiselect>
          </b-form-group>

          <b-form-group>
            <label for="local_stock_sector_id">Setor / Destino</label>
            <multiselect
                id="local_stock_sector_id"
                autocomplete="off"
                v-model="selectedLocalStockSector"
                :options="localStockSectorOptions"
                track-by="id"
                label="name"
                :option-height="40"
                :showLabels="false"
                :searchable="true"
                placeholder="Selecione um tipo"
                class="with-border"
                @select="changeSelectedLocalStockSector"
                ref="local_stock_sector_id"
            >
              <template slot="caret">
                <div class="chevron">
                  <v-chevron-down />
                </div>
              </template>
              <template slot="noOptions"> Nenhuma opção </template>
              <template slot="noResult"> Nenhum resultado </template>
            </multiselect>
          </b-form-group>

          <b-form-group>
            <label for="period">
              Fabricação
            </label>
            <div class="multiselect-container">
              <Periods
                  @select="handlePeriodManufacturing"
                  ref="periodsRefManufacturing"
              />
            </div>
          </b-form-group>

          <b-form-group>
            <label for="period">
              Validade
            </label>
            <div class="multiselect-container">
              <Periods
                  @select="handlePeriodValidity"
                  ref="periodsRefValidity"
              />
            </div>
          </b-form-group>

          <b-form-group>
            <v-select
                label="Vencimento"
                placeholder="Selecionar"
                v-model="filters.expiration"
                v-bind:options="[ { label: 'Selecionar', value: null }, { label: 'Vencimento próximo',value: 'toExpire' }, { label: 'Produtos vencidos', value: 'expired' } ]"
                v-on:onChange="value => (filters.expiration = value)"
            />
          </b-form-group>

        </section>

        <div class="wrapper-button">
          <b-button block variant="primary" @click="saveChanges">
            Confirmar
          </b-button>

          <b-button
              @click="resetForm"
              variant="outline-primary"
          >
            Redefinir
          </b-button>

        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>

import { getCurrentClinic, userHasPermission } from '@/utils/localStorageManager'

export default {
  components: {
    'v-chevron-down': () => import('@/assets/icons/chevron-down.svg'),
    Close: () => import('@/assets/icons/close.svg'),
    Search: () => import('@/assets/icons/search.svg'),
    Periods: () => import('@/components/General/Periods'),
    'v-select': () => import('@/components/Select')
  },
  props: {
    batchId: String,
  },
  mounted() {
    this.getStockLocation();
  },
  data() {
    return {
      clinic: getCurrentClinic(),
      selectedStockLocation: null,
      selectedLocalStockSector: null,
      stockLocations: [],
      localStockSectorOptions: [],
      filters: {
        period_manufacturing: {
          type: 'create',
          'start': null,
          'end': null
        },
        period_validity: {
          type: 'create',
          'start': null,
          'end': null
        },
        product_or_batch: null,
        expiration: null
      },
      langDatePicker: {
        formatLocale: {
          weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
        }
      }
    }
  },
  methods: {
    userHasPermission,
    async getStockLocation() {
      const isLoading = this.$loading.show();
      this.api.getWarehouseLocations(this.clinic.id)
          .then(res => {
            this.stockLocations = res.data;
          })
          .catch(err => this.$toast.error(err.message))
          .finally(() => isLoading.hide());
    },
    handlePeriodManufacturing(value) {
      this.filters.period_manufacturing.type = 'create';
      this.filters.period_manufacturing.start = value.start;
      this.filters.period_manufacturing.end = value.end;
    },
    handlePeriodValidity(value) {
      this.filters.period_validity.type = 'create';
      this.filters.period_validity.start = value.start;
      this.filters.period_validity.end = value.end;
    },
    changeSelectedStockLocation(value) {
      this.localStockSectorOptions = value.sectors;
      this.filters.stock_location_id = value.id;
    },
    changeSelectedLocalStockSector(value) {
      this.filters.local_stock_sector_id = value.id;
    },
    async saveChanges() {
      const isLoading = this.$loading.show()
      const filters = this.filters;

      if(!filters.period?.start || !filters.period?.end) delete filters.period

      try {
        this.$emit('change', filters);
        this.$emit('updateFilterApplied');
        this.$root.$emit('bv::toggle::collapse', 'filter-batch-sidebar')
      } catch (err) {
        this.$toast.error(err.message)
      } finally {
        isLoading.hide()
      }
    },
    async resetForm() {
      this.filters = {
        period_manufacturing: {
          type: 'create',
              'start': null,
              'end': null
        },
        period_validity: {
          type: 'create',
              'start': null,
              'end': null
        },
        product_or_batch: null,
        expiration: null
      };

      this.$refs.periodsRefManufacturing.clearCustom();
      this.$refs.periodsRefValidity.clearCustom();

      this.$emit('change', {});
      this.$emit('updateFilterApplied');
      this.$root.$emit('bv::toggle::collapse', 'filter-batch-sidebar')
    },
  },
  watch: {
    filters: {
      handler(newValue) {

      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.search-container {
  display: flex;
  flex-direction: row;
  position: relative;

  .icon-search {
    position: absolute;
    width: 24px;
    height: 24px;
    stroke: var(--neutral-500);
    margin: 7px 8px;
  }

  input {
    padding-left: 40px !important;
  }

}

#filter-batch-sidebar {
  min-width: 450px;

  .title {
    display: flex;
    flex-direction: row;

    h4 {
      color: var(--dark-blue);
      font-weight: 700;
      font-size: 18px;
      margin-right: 20px;
    }

    h5 {
      color: var(--blue-600);
      font-weight: 600;
      font-size: 18px;

      span {
        color: var(--neutral-500);
      }
    }
  }

  .guides-summary {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 5px;
    padding: 20px;
    border-radius: 8px;
    border: 1px dashed var(--neutral-300);
    background: var(--neutral-100);

    .guides-summary-row {
      display: grid;
      grid-template-columns: auto 1fr auto 3fr;
      gap: 10px;
    }

    dt {
      color: var(--neutral-700);
    }

    dd {
      margin: 0;
    }
  }

  .guides-container {
    display: flex;
    flex-direction: column;
    width: 100%;

    .guide-container {
      margin: 10px 0;
    }
  }

  .container-wrapper {
    padding: 0 1rem;
  }

  .header {
    display: flex;
    width: 100%;
    padding: 1rem 0;
    justify-content: space-between;
    align-items: center;
  }

  .guides-info-title {
    font-family: 'Red Hat Display';
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    color: var(--dark-blue);
  }

  .actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
  }

  .optional {
    font-size: 14px;
    color: var(--type-placeholder);
  }

  .close {
    width: 25px;
    fill: var(--neutral-500);
  }

  .wrapper-button {
    width: 100%;
    display: flex;
    margin: 20px 0 !important;
    flex-direction: column;

    button {
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
    }

    .btn-primary {
      color: var(--neutral-000);
    }

    .btn-outline-primary {
      margin-top: 10px;
      color: var(--blue-500);
    }

    .dropdown-item {
      font-weight: 400;
    }
  }
}
</style>